import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useSignUpCardStyles = (theme: Theme) => {
  const isDarkMode = theme.palette.mode === 'dark';

  return {
    card: css({
      marginTop: '1rem',
      borderRadius: '8px',
      backgroundColor: isDarkMode ? '#424242' : '#ffffff',
    }),
    title: css({
      padding: '1rem',
      fontWeight: 'bold',
      textAlign: 'center',
      color: isDarkMode ? theme.palette.secondary.contrastText : theme.palette.text.secondary,
    }),
    imageContainer: css({
      position: 'relative',
      width: '100%',
      paddingTop: '50%', // 2:1 Aspect Ratio
      overflow: 'hidden',
    }),
    image: css({
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    }),
    description: css({
      textAlign: 'center',
      color: isDarkMode ? theme.palette.text.disabled : theme.palette.text.secondary,
    }),
  };
};
